// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1CAik","title":"ClientCherryInfo_title__25UBM","itemText":"ClientCherryInfo_itemText__2EdKv"};